import React, { useState } from "react";
import "./DashboardContent.css";
import NukaCarousel from "nuka-carousel";
import DashboardTestimonials from "../data/DashboardTestimonials.json";
// import FameWallData from "../data/FameWallData.json";
import DashboardFamewall from "../data/DashboardFamewall.json";
import DashboardOverallSection from "./DashboardOverallSection";
import FloatIcon from "./FloatIcons/FloatIcons";
// import { BsFillArrowLeftCircleFill, BsFillArrowRightCircleFill } from 'react-icons/bs';

function DashboardContent() {
  const [lang, setLang] = useState("all");
  const [readMore, showReadMore] = useState(false);
  const [expand, setExpand] = useState(-1);
  const toggleReadMore = (id) => {
    if (expand == id) {
      setExpand(-1);
    } else {
      setExpand(id);
    }
  };

  const [selectedPeople, setSelectedPeople] = useState(true);
  return (
    <>
      {/* Float Icon Start */}
      <div className="floatIconsContainer">
        <FloatIcon />
      </div>
      {/* Float Icon End */}
      {/* <div className="main-banner">
        <img
          src="/images/Dashboard/dashboard-banner.png"
          alt="banner"
          className="dashboard-banner"
        />
        <h2 id="ourLeadBannerText"> LKM Foreign Language Trainings - European Dashboard</h2>
        
      </div> */}

      {/* <DashboardOverallSection /> */}
      {/* Section 2  */}
      {/*  */}
      {/* Section Two Updated Start */}
      {/* <section className="fameWallContainer">
        <h3 className="fameWallHeading">
          <span style={{ fontFamily: "Graphik-Semibold" }}>Fame Wall: </span>
          <span style={{ fontFamily: "Graphik-Regular" }}>
            Honoring Our Champions!
          </span>
        </h3>
        <div className="fameWallGridContainer">
          <div className="fameWallGridContentLeft">
            <img
              src="/images/Dashboard/FameWall/overall-card-bg.png"
              alt="Bg"
              className="fameWallBg"
            />
            <p className="fameWallLeftHeading">Overall</p>
            <div className="fameWallOverallBadgeContainer">
              <div className="fameWallOverallBadgeWrapper">
                <img
                  src="/images/Dashboard/FameWall/Overall-Internal-Certified-badge.png"
                  alt="Internally"
                  className="fameWallInternallyBadge"
                />
                <p className="fameWallInternallyBadgeText">1000+</p>
              </div>
              <div className="fameWallOverallBadgeWrapper">
                <img
                  src="/images/Dashboard/FameWall/Overall-External-Certified-badge.png"
                  alt="Internally"
                  className="fameWallInternallyBadge"
                />
                <p className="fameWallExternallyBadgeText">95+</p>
              </div>
            </div>
          </div>
          <div className="fameWallGridContentRight">
            {DashboardFamewall.map((item) => {
              return (
                <div className="fameWallRightCards">
                  <p
                    className="fameWallRightCardsHeading"
                    style={{ backgroundColor: item.headingBackground }}
                  >
                    {item.languageHeading}
                  </p>
                  <div className="fameWallRightCardsContentGrid">
                    <div className="fameWallRightCardsInterallyCertified">
                      <img
                        src={item.internallyCertImgPath}
                        alt="Internally"
                        className="fameWallExternallyBadge"
                      />
                      <p className="fameWallRightCardsInterallyCertifiedText">
                        {item.internallyCert}
                      </p>
                    </div>
                    <div className="fameWallRightCardsInterallyCertified">
                      <img
                        src={item.externallyCertImgPath}
                        alt="Internally"
                        className="fameWallExternallyBadge"
                      />
                      <p className="fameWallRightCardsInterallyCertifiedText">
                        {item.externallyCert}
                      </p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section> */}
      {/* Section Two Updated End */}
      {/* section 3  */}
      {/* <div className="fameCarousel-container">
        <img
          src="/images/Dashboard/quote1.png"
          alt="double-quote"
          className="quote1"
        />
        <div className="fameCarousel-wrap">
          <div className="fameCarousel-row">
            <div className="fameCarousel-box">
              <div className="fameCarousel-text">
                <h3>Thrilled Learners</h3>
                <h4>
                  Hear Their <br />
                  Testimonials!
                </h4>
                <p>
                  European language testimonials celebrate linguistic diversity
                </p>
                <br />
              </div>
              <NukaCarousel
                cellAlign="right"
                slidesToShow={3}
                cellSpacing={15}
                renderCenterLeftControls={({ previousSlide }) => (
                  <span onClick={previousSlide} className="prev-button">
                    <BsFillArrowLeftCircleFill />
                    {"<"}
                  </span>
                )}
                renderCenterRightControls={({ nextSlide }) => (
                  <span onClick={nextSlide} className="next-button">
                    <BsFillArrowRightCircleFill />
                    {">"}
                  </span>
                )}
              >
                {DashboardTestimonials.map((item, i) => {
                  return (
                    <div className="dtestimonials-container">
                      <div className="dtestimonials-wrap">
                        <div className="dtestimonials-row">
                          <div className="dtestimonials-box">
                            <div className="imageWrap">
                              
                              <img
                                src="/images/Dashboard/quote2.png"
                                alt="double-quote"
                                className="quote2"
                              />
                            </div>
                            <div className="dtestimonials-content">
                              <p className="dtestimonials-feedback">
                                {expand !== i
                                  ? item.feedback
                                  : item.feedback + item.feedbackHidden}
                                <span
                                  style={{
                                    color: "blue",
                                    fontSize: ".75rem",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => toggleReadMore(item.id)}
                                >
                                  <br />
                                  {expand != i ? "Read More..." : " Show Less"}
                                </span>
                              </p>
                              <br />
                              <p className="dtestimonials-name">{item.name}</p>
                              <p className="dtestimonials-language">
                                {item.language}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </NukaCarousel>
            </div>
          </div>
        </div>
      </div> */}
      {selectedPeople && (
        <div className="overallSectionContainer">
          <iframe
            title="European Language _Dashboard_Updated"
            width="100%"
            height="541.25"
            src="https://app.powerbi.com/reportEmbed?reportId=78341e18-9f4c-450b-9dc6-38d5a73d6f93&autoAuth=true&ctid=e0793d39-0939-496d-b129-198edd916feb"
            frameborder="0"
            allowFullScreen="true"
          ></iframe>
        </div>
      )}
    </>
  );
}

export default DashboardContent;
